import { FleekError } from './FleekError';

type ProjectMembershipsLimitExceededErrorOptions = Record<string, never>;

export class ProjectMembershipsLimitExceededError extends FleekError<ProjectMembershipsLimitExceededErrorOptions> {
  public name = 'ProjectMembershipsLimitExceededError';

  toString = () => `Your project is growing! You've reached the maximum number of memberships for this project. Upgrade your plan at https://fleek.xyz/pricing to add more members. Need assistance? Our Support team is ready to help.`
}
